module.exports = __webpack_public_path__ + "img/film-reviews.48cf9c1d.jpeg";